import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import phThinking from "../../../assets/images/blurred2/imoji/thinking.png";
import phBalance from "../../../assets/images/blurred2/workSituation/balance.webp";
import phGear from "../../../assets/images/blurred2/workSituation/gear.webp";
import HorizontalLeftButton from "../../../components/HorizontalLeftButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url } from "../../../utils/modules";

const imagesToPreload = {
  male: ["/staging/goal/male/3.png"],
  female: ["/staging/goal/female/3.png"],
};
const buttonText = [
  t("work_situation.remote_balance"),
  t("work_situation.stable_routine"),
  t("work_situation.exploring_options"),
];
const data = [
  {
    image: addS3Url("/workSituation/balance.png"),
    placeHolderImage: phBalance,
  },
  {
    image: addS3Url("/workSituation/gear.png"),
    placeHolderImage: phGear,
  },
  {
    image: addS3Url("/imoji/thinking.png"),
    placeHolderImage: phThinking,
  },
];

const WorkSituation = () => {
  const params = useParams();
  const gender = params.gender || "female";

  return (
    <MobileViewLayout>
      <div className="px-4 d-flex flex-column justify-content-center align-items-center ">
        <h2 className="text-black fw-bold text-center  m-0 fs30 remote-selection-heading workSituation-heading">
          <Trans i18nKey={"work_situation.question"} />
        </h2>
        <div className="w-100 d-flex flex-column gap-1 income-slab-option">
          {data.map((item, index) => (
            <HorizontalLeftButton
              key={index}
              navigateTo={{
                pathname: `/${params.gender}/travel`,
              }}
              label={buttonText[index]}
              className=" fsituation-button-text workSituation-text fs18 "
              imgClass="button-image"
              imagesToPreload={imagesToPreload[gender]}
              {...item}
            />
          ))}
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default WorkSituation;
